/**
* Featured Stories JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Stories component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'featured-stories',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      gsap.utils.toArray( '.short.red-cover-animation' ).forEach( ( shortRed ) => {
        gsap.to( shortRed, {
          scrollTrigger: {
            trigger: shortRed,
            start: 'top 85%',
          },
          ease: true,
          duration: .025,
          y: 230,
          backgroundColor: '#DA272D',
        } );
      } );
      gsap.utils.toArray( '.tall.red-cover-animation' ).forEach( ( tallRed ) => {
        gsap.to( tallRed, {
          scrollTrigger: {
            trigger: tallRed,
            start: 'top 85%',
          },
          ease: true,
          duration: .025,
          y: 546,
          backgroundColor: '#DA272D',
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-stories', COMPONENT );
} )( app );
